/* MÁ UŽIVATEL TÝM? — jediný zdroj pravdy pro menu a obrazovky Tým.
 * ============================================================================
 * Dřív rozhodovala jen ROLE (admin / manager). Jenže roli manager v appce nikdo
 * nepřidělí: registrace dává „user“, SSO roli přepíše z IdP. Tým přitom vzniká
 * přijetím pozvánky — kdo někoho pozval a ten přijal, svůj tým neviděl, i když
 * backend data vydá (rozhoduje podle potvrzených vztahů, ne podle role).
 *
 * maTym(user):
 *   1. role admin / manager → ano,
 *   2. backend poslal `tym_clenu` (celé číslo) → ano, jen když je > 0,
 *      (null = backend počet nezjistil → ne; fail-closed),
 *   3. backend `tym_clenu` vůbec neposlal (starší nasazení, před redeployem
 *      u Emergentu) → NÁHRADA: aspoň jedna MNOU odeslaná pozvánka ve stavu
 *      „accepted“ (zjistí Nastavení → Můj tým nebo brána obrazovky Tým).
 *
 * Brána je jen UX. Data dál hlídá každý endpoint přes potvrzené vztahy, takže
 * omyl tady nikomu nic nezpřístupní — nanejvýš ukáže prázdnou obrazovku.
 *
 * Modul SCHVÁLNĚ nesahá na síť (žádný import api): čte ho levá lišta na každé
 * obrazovce a její testy api nemockují. Dotaz na pozvánky dělá TymBrana.
 */
import { useSyncExternalStore } from "react";

export const MANAZERSKE_ROLE = ["admin", "manager"];

const KLIC = "beplan.tymNahrada";
const posluchaci = new Set();

function ctiNahradu() {
  try {
    const v = window.sessionStorage.getItem(KLIC);
    return typeof v === "string" && v ? v : null;
  } catch {
    return null;
  }
}

let nahradaPro = ctiNahradu(); // id uživatele, u kterého jsme přijatou pozvánku viděli

function oznam() {
  posluchaci.forEach((f) => { try { f(); } catch { /* posluchač nesmí shodit ostatní */ } });
}

/** Zapamatuje (pro tuto záložku prohlížeče), že uživatel `uid` má přijatou odchozí pozvánku. */
export function nastavNahraduTymu(uid) {
  if (!uid) return;
  nahradaPro = String(uid);
  try { window.sessionStorage.setItem(KLIC, nahradaPro); } catch { /* privátní režim */ }
  oznam();
}

export function zapomenNahraduTymu() {
  nahradaPro = null;
  try { window.sessionStorage.removeItem(KLIC); } catch { /* noop */ }
  oznam();
}

function idUzivatele(user) {
  return user ? String(user.id || user._id || "") : "";
}

/** Potřebuje tenhle uživatel náhradu (backend bez tym_clenu)? */
export function potrebujeNahradu(user) {
  return !!user && !MANAZERSKE_ROLE.includes(user.role) && user.tym_clenu === undefined;
}

export function maTym(user) {
  if (!user || typeof user !== "object") return false;
  if (MANAZERSKE_ROLE.includes(user.role)) return true;
  const n = user.tym_clenu;
  if (n === undefined) {
    const uid = idUzivatele(user);
    return !!uid && nahradaPro === uid;
  }
  return Number.isInteger(n) && n > 0;
}

/** Je mezi odchozími pozvánkami aspoň jedna přijatá? */
export function maPrijatouPozvanku(pozvanky) {
  return Array.isArray(pozvanky) && pozvanky.some((p) => p && p.status === "accepted");
}

function prihlasit(f) {
  posluchaci.add(f);
  return () => posluchaci.delete(f);
}

/** maTym jako hook — překreslí se, když se náhrada zjistí jinde (Nastavení). */
export function useMaTym(user) {
  const nahrada = useSyncExternalStore(prihlasit, () => nahradaPro, () => null);
  void nahrada; // jen kvůli překreslení; hodnotu čte maTym
  return maTym(user);
}
